import script from "./SideBarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarItem.vue?vue&type=script&setup=true&lang=js"

import "./SideBarItem.vue?vue&type=style&index=0&id=2ca6161a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca6161a"]])

export default __exports__